/**
 * Layout principal do Sistema MEDICARE
 * Componente que envolve todas as páginas protegidas
 */

import React from 'react';
import {
  Box,
  Flex,
  useDisclosure,
  useColorModeValue,
} from '@chakra-ui/react';
import { Outlet } from 'react-router-dom';
import { Sidebar } from './Sidebar';
import { Header } from './Header';
import { MobileSidebar } from './MobileSidebar';

export const Layout: React.FC = () => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const bgColor = useColorModeValue('gray.50', 'gray.900');

  return (
    <Box minH="100vh" bg={bgColor}>
      {/* Sidebar para desktop */}
      <Sidebar
        onClose={onClose}
        display={{ base: 'none', md: 'block' }}
      />
      
      {/* Sidebar para mobile */}
      <MobileSidebar
        isOpen={isOpen}
        onClose={onClose}
      />
      
      {/* Conteúdo principal */}
      <Flex
        ml={{ base: 0, md: 60 }}
        direction="column"
        minH="100vh"
      >
        {/* Header */}
        <Header onOpen={onOpen} />
        
        {/* Área de conteúdo */}
        <Box
          flex="1"
          p={{ base: 4, md: 6 }}
          overflow="auto"
        >
          <Outlet />
        </Box>
      </Flex>
    </Box>
  );
};

export default Layout;